<template>
  <el-card
      class="item-card"
      shadow="never"
      style="border-radius: 4px !important; border: 1px solid #dee5ec;background-color:rgb(250, 251, 252); "
      body-style="margin: 0px;">
    <div
        class="item-names"
        style="margin: 8px 24px 24px 8px">
      <p>No shipping info available yet</p>
    </div>
  </el-card>
</template>
<script>
export default {
  name: "ShippingDetailsNotAvailable",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
};
</script>

<style>
.item-names {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  color: #81919f;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  text-align: center;
}
</style>
